import styled from 'styled-components'

import { IconButton } from '@components/shared/icon-button'
import TextField from '@components/shared/TextField'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px 1fr;
  gap: 12px;
  align-items: center;
`

const ControlButton = styled(IconButton)`
  background-color: ${({ theme, disabled }) =>
    disabled
      ? theme.palette.common.lightGray
      : theme.palette.common.lightPrimary} !important;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  cursor: pointer;
  padding: 12px;
  width: 36px;
  height: 36px;

  svg {
    fill: ${({ theme, disabled }) =>
      disabled ? theme.palette.text.tertiary : theme.palette.brand.primaryBlue};

    width: 100%;
    height: 100%;
  }
`

const ValueField = styled(TextField).attrs((props) => ({
  variant: 'outlined',
  type: 'number',
  inputProps: {
    inputMode: 'numeric',
  },
  ...props,
}))`
  color: ${({ theme, disabled }) =>
    disabled ? theme.palette.text.disabled : theme.palette.text.primary};

  text-align: center;
  white-space: nowrap;

  .MuiOutlinedInput-root input,
  .MuiFilledInput-root input {
    font-size: 16px;
    font-weight: 700;
    padding: 10px;
  }
`

export const counterStyles = {
  Container,
  ControlButton,
  ValueField,
}
